export { default } from './Footer2';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Footer/Footer2/index.js